import { useMutation } from '@tanstack/react-query';
import { vehicleRepository } from '../../repositories/vehicle-repository';
import { IGetChineseVehicle } from '../../interfaces/api-chinese-vehicle-interface';

export const useGetChineseVehicle = () =>
  useMutation((data: IGetChineseVehicle) => vehicleRepository.getChineseVehicle(data.id));
